export default "__VITE_ASSET__CagU1XGE__"